import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { TextField, Grid, Typography, Divider, RadioGroup, FormControlLabel, Radio, FormControl } from '@material-ui/core'
import { cutMaxLength } from 'utils/helpers'
import { SecaoGenerica, CustomButton } from 'components'
import useStyles from './Formulario.styles'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const Formulario = (props) => {
  const { className, vestigio, isProcessando, onConfirm, onCancel, ...rest } = props
  const classes = useStyles()

  const [values, setValues] = useState({
    lacre: '',
    tipoEmbalagem: '',
    outroTipoEmbalagem: '',
    localizacao: '',
  })

  const [touched, setTouched] = useState({
    lacre: false,
    localizacao: false,
  })

  useEffect(() => {
    if (vestigio) {
      setValues({
        lacre: vestigio.lacre || '',
        tipoEmbalagem: vestigio.tipoEmbalagem || '',
        outroTipoEmbalagem: vestigio.outroTipoEmbalagem || '',
        localizacao: '',
      })
    }
  }, [vestigio])

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleChangeWithModification = (e, modificationFn) => {
    const { name, value } = e.target
    setValues((prev) => ({
      ...prev,
      [name]: modificationFn(value),
    }))
  }

  const handleBlur = (e) => {
    const { name } = e.target
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }))
  }

  const errors = {
    lacre: !values.lacre?.trim() ? 'Lacre é obrigatório' : null,
    localizacao: !values.localizacao?.trim() ? 'Localização é obrigatória' : null,
  }

  const isFormError = !!(errors.lacre || errors.localizacao)

  const handleConfirm = () => {
    setTouched({
      lacre: true,
      localizacao: true,
    })
    if (!isFormError) {
      onConfirm(values)
    }
  }

  return (
    <div {...rest} className={clsx(classes.results, className)}>
      <Grid item md={3} sm={6} xs={12} style={{ marginBottom: '16px' }}>
        <TextField
          error={touched.lacre && !!errors.lacre}
          fullWidth
          helperText={touched.lacre && errors.lacre ? errors.lacre : null}
          variant="outlined"
          label="NÚMERO DO LACRE"
          name="lacre"
          onChange={(e) => handleChangeWithModification(e, maxLength250)}
          onBlur={handleBlur}
          value={values.lacre}
          required
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
          Caracteres restantes: {250 - (values.lacre?.length || 0)}
        </Typography>
      </Grid>

      <Grid item container md={12} sm={12} xs={12} style={{ marginBottom: '16px' }}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px' }}>TIPO DA EMBALAGEM</Typography>
        </Grid>
        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            aria-label="tipo-embalagem"
            name="tipoEmbalagem"
            value={values.tipoEmbalagem || null}
            onChange={handleChange}
            style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
          >
            <FormControlLabel value="SACO LACRE" control={<Radio color="primary" />} label={<Typography variant="body2">SACO LACRE</Typography>} />
            <FormControlLabel value="PLÁSTICO" control={<Radio color="primary" />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
            <FormControlLabel value="ENVELOPE PAPEL" control={<Radio color="primary" />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
            <FormControlLabel value="CAIXA" control={<Radio color="primary" />} label={<Typography variant="body2">CAIXA</Typography>} />
            <FormControlLabel value="AUSENTE" control={<Radio color="primary" />} label={<Typography variant="body2">AUSENTE</Typography>} />
            <FormControlLabel value="OUTRO" control={<Radio color="primary" />} label={<Typography variant="body2">OUTRO</Typography>} />
          </RadioGroup>
        </FormControl>
        <Grid item md={12} sm={12} xs={12} style={{ marginTop: '8px' }}>
          <TextField
            label="OUTRO TIPO DE EMBALAGEM"
            name="outroTipoEmbalagem"
            variant="outlined"
            value={values.outroTipoEmbalagem}
            onChange={handleChange}
            disabled={values.tipoEmbalagem !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>


      <SecaoGenerica titulo="Informações de Localização" spacing={2}>
        <Grid item md={10} sm={12} xs={12} style={{ marginBottom: '16px' }}>
          <TextField
            value={values.localizacao}
            error={touched.localizacao && !!errors.localizacao}
            fullWidth
            helperText={touched.localizacao && errors.localizacao ? errors.localizacao : null}
            label="LOCAL ONDE SERÁ GUARDADO"
            name="localizacao"
            onChange={(e) => handleChangeWithModification(e, maxLength250)}
            onBlur={handleBlur}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            required
          />
          <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
            Caracteres restantes: {250 - (values.localizacao?.length || 0)}
          </Typography>
        </Grid>
      </SecaoGenerica>




      <Divider style={{ margin: '32px 0 16px 0' }} />

      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
        <CustomButton
          colorType="primary"
          variant="outlined"
          onClick={onCancel}
          startIcon={<ArrowBackIcon />}
        >
          Voltar
        </CustomButton>
        <CustomButton
          colorType="secondary"
          variant="contained"
          disabled={isFormError || isProcessando}
          isLoading={isProcessando}
          startIcon={<CheckIcon />}
          onClick={handleConfirm}
        >
          Confirmar
        </CustomButton>
      </div>
    </div>
  )
}

